import { render, staticRenderFns } from "./dg-footer.vue?vue&type=template&id=474dbcc8&scoped=true"
import script from "./dg-footer.vue?vue&type=script&lang=js"
export * from "./dg-footer.vue?vue&type=script&lang=js"
import style0 from "./dg-footer.vue?vue&type=style&index=0&id=474dbcc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474dbcc8",
  null
  
)

export default component.exports